module.exports = __webpack_public_path__ + "img/windows-store.82e6012a.png";